var base = require('settings/teams/team-profile');

Vue.component('spark-team-profile', {
    mixins: [base]
});



// WEBPACK FOOTER //
// ./resources/js/spark-components/settings/teams/team-profile.js